import { Check, SkipForward, FileSpreadsheet, Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

/** Toplu aktarım kuyruğu şeridi — dosya durumları (bekliyor / işleniyor / aktarıldı / atlandı). */
export default function QueueStrip({ queue, current, onJump }) {
  const done = queue.filter((q) => q.status === "done").length;
  return (
    <div className="shrink-0 border-b bg-[#0f2140] text-white px-4 py-2 flex items-center gap-3 overflow-x-auto" data-testid="import-queue">
      <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#ffb27a] shrink-0 font-head">Kuyruk · {done}/{queue.length} aktarıldı</span>
      <ol className="flex items-center gap-1.5">
        {queue.map((q, i) => {
          const on = i === current;
          const cls = on ? "bg-primary border-primary text-white" : q.status === "done" ? "bg-emerald-500/15 border-emerald-400/40 text-emerald-200" : q.status === "skipped" ? "bg-white/5 border-white/10 text-slate-400 line-through" : "bg-white/5 border-white/15 text-slate-200 hover:bg-white/10 cursor-pointer";
          return (
            <li key={i}>
              <button type="button" onClick={() => onJump(i)} disabled={q.status !== "pending" || on} className={cn("flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold whitespace-nowrap transition-colors disabled:cursor-default", cls)} title={q.name} data-testid={`import-queue-file-${i}`}>
                {on ? <Loader2 className="h-3 w-3 animate-spin" /> : q.status === "done" ? <Check className="h-3 w-3" /> : q.status === "skipped" ? <SkipForward className="h-3 w-3" /> : <FileSpreadsheet className="h-3 w-3 opacity-70" />}
                <span className="opacity-70">{i + 1}.</span>{q.name.replace(/\.[^.]+$/, "")}
                {q.status === "done" && q.result && <span className="opacity-80">· {Number(q.result.total || 0).toLocaleString("tr-TR", { maximumFractionDigits: 0 })} ₺</span>}
              </button>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
